import React from 'react'
import { Key } from '../'
import './styles.scss'

export const Chart = ({
  children,
  update,
  title,
  sub,
  source,
  footnote,
  keyentries
}: {
  children?: React.ReactChild
  update?: string | React.ReactChild
  title?: string | React.ReactChild
  sub?: string | React.ReactChild
  footnote?: string | React.ReactChild
  source?: string | React.ReactChild
  keyentries?: KeyEntryType[]
}) => {
  if (!children && !update && !title && !sub && !source && !footnote) {
    title = 'This is the title of chart'
    sub = 'This is the subline of chart'
    update = 'Updated on 1. January 2000'
    source = 'This is the source of chart'
    footnote = 'This is the footnote of chart'
    children = (
      <svg
        style={{ backgroundColor: '#eee', width: '100%', height: '300px' }}
      ></svg>
    )
  }

  return (
    <div className='Chart'>
      {update && <div className='updatenote'>{update}</div>}
      {title && <div className='title'>{title}</div>}
      {sub && <div className='sub'>{sub}</div>}{' '}
      <div className='chart'>
        {keyentries && <Key entries={keyentries} />}
        {children && children}
      </div>
      {(footnote || source) && <div className='spacer' />}
      {footnote && <div className='source'>{footnote}</div>}
      {source && <div className='source'>{source}</div>}
    </div>
  )
}
